'use client';

import { useClientRouterSync } from '@/hooks/useClientRouterSync';

// This is a Client Component. Because it has the 'use client' directive,
// it is allowed to call client-side hooks.
export function ClientRouterSync() {
  // Call your hook here
  useClientRouterSync();

  // This component doesn't render any visible HTML
  return null;
}